/**
 * `goodleap.plus` only: `/` = GoodLeap Plus marketing, `/:id` = apply. Matches `www.goodleap.plus`.
 * `goodleap.plus` is not included — same SPA routes as goodleap.dev (`/:client/:id`, etc.).
 */
export function isGoodLeapPlusDomain() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h.includes("goodleap.plus");
}
